import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { MutationScope } from '@tanstack/react-query';

import collectiveApi from 'modules/common/collectiveApi';

// A request that never settles would hold every mutation queued behind it in the same scope.
const REQUEST_TIMEOUT_MS = 30_000;

interface UpdateOnboardingStepParams {
    step: string;
    status: string;
    data?: Record<string, unknown>;
}

const updateOnboardingStep = async (params: UpdateOnboardingStepParams) => {
    const response = await collectiveApi.post('/bookkeeping/accounting-onboarding/update_step/', params, {
        timeout: REQUEST_TIMEOUT_MS,
    });
    return response.data;
};

// Mutations sharing a scope run one at a time, in the order they were made.
const useUpdateOnboardingStep = ({ scope }: { scope?: MutationScope } = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateOnboardingStep,
        scope,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['accounting-onboarding-progress'] });
        },
        onError: () => {
            // Handle error
        },
    });
};

export default useUpdateOnboardingStep;
